// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// On Firebase Hosting the sign-in helper (/__/auth/handler) is served from the
// site's own domain (allowed in the Google OAuth client). Using it keeps Google
// sign-in first-party, which Android Chrome, Safari and installed (PWA) apps
// need. The bare infinitycreative.agency only redirects to www, so it signs in
// through www (same site, so the browser still treats it as first-party).
// Anywhere else (localhost) use the env value.
const authDomainFor = (host) => {
  if (/(^|\.)infinitycreative\.agency$/.test(host)) return 'www.infinitycreative.agency';
  if (/\.(web\.app|firebaseapp\.com)$/.test(host)) return host;
  return process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
};
const hostedAuthDomain = typeof window !== 'undefined'
  ? authDomainFor(window.location.hostname)
  : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: hostedAuthDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

// Firebase Auth je izdvojen u src/firebase-auth.js — getAuth() povlači Google
// OAuth iframe (apis.google.com) koji postavlja treće-party kolačiće, pa auth
// smijemo importati samo iz lazy-loadanih admin/login chunkova.

export { app, db, storage };
